import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Award, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export default function MyCertificates() {
    const nav = useNavigate();
    const [rows, setRows] = useState(null);
    useEffect(() => { api.get("/certificates/mine").then((r) => setRows(r.data)); }, []);
    if (rows === null) return <div className="p-8 text-neutral-500">Loading…</div>;
    return (
        <div className="min-h-screen bg-neutral-950 text-neutral-100">
            <header className="border-b border-neutral-800">
                <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
                    <Button size="sm" variant="ghost" onClick={() => nav("/learn")} data-testid="btn-back-dashboard-cert"><ArrowLeft size={14} className="mr-1"/>Dashboard</Button>
                    <div className="font-semibold">My Certificates</div>
                    <div/>
                </div>
            </header>
            <main className="max-w-4xl mx-auto px-6 py-8">
                {rows.length === 0 ? (
                    <Card><CardContent className="py-14 text-center text-neutral-400" data-testid="empty-certificates">No certificates yet. Complete an assignment to earn one.</CardContent></Card>
                ) : (
                    <div className="space-y-3">
                        {rows.map((c) => (
                            <Card key={c.id} data-testid={`certificate-card-${c.id}`}>
                                <CardContent className="p-5 flex items-center gap-4">
                                    <Award className="text-amber-500 shrink-0" size={32}/>
                                    <div className="flex-1 min-w-0">
                                        <div className="font-semibold truncate">{c.module_title}</div>
                                        <div className="text-sm text-neutral-400">Completed {new Date(c.completion_date).toLocaleDateString()} · Score {c.score.toFixed(0)}%</div>
                                        {c.doc_number && <div className="text-xs text-neutral-500 mt-0.5">{c.doc_number}{c.revision ? ` · Rev. ${c.revision}` : ""}</div>}
                                    </div>
                                    <div className="flex gap-2">
                                        {c.pdf_download_url && (
                                            <Button size="sm" onClick={async () => {
                                                try {
                                                    const r = await api.get(`/certificates/${c.id}/pdf`, { responseType: "blob" });
                                                    const href = URL.createObjectURL(r.data);
                                                    const link = document.createElement("a");
                                                    link.href = href;
                                                    link.download = `certificate_${c.id.slice(0, 8)}.pdf`;
                                                    document.body.appendChild(link);
                                                    link.click();
                                                    link.remove();
                                                    URL.revokeObjectURL(href);
                                                } catch (e) {
                                                    // handled silently — button is a nice-to-have
                                                }
                                            }} data-testid={`btn-download-cert-${c.id}`}>Download PDF</Button>
                                        )}
                                        <a href={`/api/certificates/verify/${c.verify_token}`} target="_blank" rel="noreferrer">
                                            <Button size="sm" variant="outline" data-testid={`btn-verify-cert-${c.id}`}><ExternalLink size={14} className="mr-1"/>Verify</Button>
                                        </a>
                                    </div>
                                </CardContent>
                            </Card>
                        ))}
                    </div>
                )}
            </main>
        </div>
    );
}
